import React, { useEffect, useState } from 'react'
import Loader from '../../components/common/GlobalLoader'

const MyAccount = () => {
  const [userData, setUserData] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchUser = () => {
      const storedUser = localStorage.getItem('user')
      if (storedUser) {
        try {
          const parsedUser = JSON.parse(storedUser)
          setUserData(parsedUser)
        } catch (error) {
          console.error('Error parsing user data:', error)
        }
      }
      setLoading(false)
    }

    // Simulate async fetch (you can remove timeout if unnecessary)
    setTimeout(fetchUser, 500)
  }, [])

  return (
    <div className="relative">
      {/* 🔄 Fullscreen Loader Overlay */}
      {loading && (
        <div className="fixed inset-0 bg-white/70 z-50 flex items-center justify-center">
          <Loader />
        </div>
      )}

      {/* Main content container */}
      <div className={`bg-white border rounded-xl p-4 sm:p-6 shadow-md max-w-7xl mx-auto transition-opacity duration-300 ${loading ? 'opacity-30 pointer-events-none select-none' : ''}`}>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          {/* Customer Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">User Name</label>
            <input
              type="text"
              value={userData.CustomerName || ''}
              disabled
              className="w-full border border-gray-300 rounded-md px-3 py-2 bg-gray-100 text-gray-700"
            />
          </div>

          {/* Customer ID */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">ID #</label>
            <input
              type="text"
              value={userData.CustomerID || ''}
              disabled
              className="w-full border border-gray-300 rounded-md px-3 py-2 bg-gray-100 text-gray-700"
            />
          </div>

          {/* Company Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Account Name</label>
            <input
              type="text"
              value={userData.CompanyName || 'N/A'}
              disabled
              className="w-full border border-gray-300 rounded-md px-3 py-2 bg-gray-100 text-gray-700"
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email"
              value={userData.email || ''}
              disabled
              className="w-full border border-gray-300 rounded-md px-3 py-2 bg-gray-100 text-gray-700"
            />
          </div>

          {/* Phone */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
            <input
              type="text"
              value={userData.phone || 'N/A'}
              disabled
              className="w-full border border-gray-300 rounded-md px-3 py-2 bg-gray-100 text-gray-700"
            />
          </div>

          {/* Address */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Address</label>
            <input
              type="text"
              value={userData.BillingAddress || 'N/A'}
              disabled
              className="w-full border border-gray-300 rounded-md px-3 py-2 bg-gray-100 text-gray-700"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default MyAccount
